import { useSearchParams } from "react-router-dom";

export function useFade(): boolean {
    const [query] = useSearchParams();
    return !!query.get('fade');
}
